import { useState, useEffect } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { useHistory, useLocation } from "react-router-dom";
import Container from "../../common/Container";
import styled from "styled-components";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
  ScrollProgress,
} from "./styles";

const Logo = styled.img`
  width: 160px;
  height: auto;
  object-fit: contain;

  @media (max-width: 768px) {
    width: 140px;
  }

  @media (max-width: 480px) {
    width: 120px;
  }
`;

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const totalHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = (window.scrollY / totalHeight) * 100;
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const navigateTo = (path: string) => {
      history.push(path);
      setVisibility(false);
    };

    const scrollTo = (id: string) => {
      if (location.pathname !== '/') {
        history.push('/');
        setTimeout(() => {
          const element = document.getElementById(id);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      } else {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
      setVisibility(false);
    };

    const currentPath = location.pathname;

    return (
      <>
        <CustomNavLinkSmall $isActive={currentPath === "/"} onClick={() => navigateTo("/")}>
          <Span>Home</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall $isActive={currentPath === "/courses"} onClick={() => navigateTo("/courses")}>
          <Span>Courses</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall $isActive={currentPath === "/services"} onClick={() => navigateTo("/services")}>
          <Span>Services</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall $isActive={currentPath === "/about"} onClick={() => navigateTo("/about")}>
          <Span>About Us</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("contact")}>
          <Span>Contact</Span>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection>
      <ScrollProgress style={{ width: `${scrollProgress}%` }} />
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <Logo src="/img/learnoza-01.png" alt="Learnoza Logo" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
